import React, { useState }  from 'react';
import { ReactSearchAutocomplete } from 'react-search-autocomplete'
import Aux from "../../hoc/Aux_";
import {
  Link,
} from "react-router-dom";
import programs from '../../assets/js/PROGRAM_EDU_ID.js';

function Program(props) {
    
      const [copySuccess, setCopySuccess] = useState('');
      const [selection, setSelection] = useState('');

      const handleOnSearch = (string, results) => {
        // onSearch will have as the first callback parameter
        // the string searched and for the second the results.
        console.log(string, results)
      }
    
      const handleOnHover = (result) => {
        // the item hovered
        console.log(result)
      }
    
      const handleOnSelect = (item) => {
        // the item selected
        console.log(item)
        setSelection(item.name);
      }
    
      const handleOnFocus = () => {
        console.log('Focused')
      }
    
      const formatResult = (item) => {
        return (
          <>
            {/*<span style={{ display: 'block', textAlign: 'left' }}>id: {item.id}</span>*/}
            <span style={{ display: 'block', textAlign: 'left' }}>{item.name}</span>
          </>
        )
      }

      const copyToClipboard = (e) => {
        //textAreaRef.current.select();
        document.execCommand('copy');
        // This is just personal preference.
        // I prefer to not show the whole text area selected.
        e.target.focus();
        navigator.clipboard.writeText(selection)
        setCopySuccess('Copied!');
      };
    
      const styling = {
        fontSize: "12px"
      }
      return (

        <div style={{ width: 600 }}>
            <br/>
            <p><b>STEP 1:</b> Please select the question corresponding to the question from the survey:</p>
            <div className="question-links">
              <ul>
                <li>
                <Link to="/jobtitle">[QN_POS_ID]: Job Title</Link>
                </li>
                <li>
                <Link to="/program">[QN_PROGRAM_EDU_ID]: Program</Link>
                </li>
              </ul>
            </div>
            <br/>
            <p><b>STEP 2:</b> Please enter and select a program:</p>
            <ReactSearchAutocomplete
            items={programs}
            onSearch={handleOnSearch}
            onHover={handleOnHover}
            onSelect={handleOnSelect}
            onFocus={handleOnFocus}
            autoFocus
            formatResult={formatResult}
            styling={styling}
            />
            <p><b>STEP 3:</b> Please copy your selection by clicking the button below, or by manually by selecting and pressing Ctrl+C:</p>
            <div>
                <button className="button" onClick={copyToClipboard}>Copy</button>
                {/*<button onClick={() =>  navigator.clipboard.writeText(selection)}>Copy</button>*/}
                {copySuccess}
            </div>
            <p><b>STEP 4:</b> Return to the survey form and paste your selection into the textfield for corresponding 
            question (Ctrl+V shortcut or by right-clicking in textfield and selecting "Paste").</p>
        </div>
      );
}

export default Program;
